import {
    ADD_SYSTEM_ADMIN_CE_PACK,
    ADD_SYSTEM_ADMIN_CE_PACKS,
    UPDATE_SYSTEM_ADMIN_CE_PACK,
    DELETE_SYSTEM_ADMIN_CE_PACK
} from './action';

// Initial State
const initialState = [];

const cePackReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_SYSTEM_ADMIN_CE_PACK: {
            const newCePackList = [...state];
            newCePackList.push(action.payload);

            return newCePackList;
        }

        case ADD_SYSTEM_ADMIN_CE_PACKS: {
            return action.payload;
        }

        case UPDATE_SYSTEM_ADMIN_CE_PACK: {
            const cePackList = [...state];
            const newCePackList = [];

            for (let i = 0; i < cePackList.length; i++) {
                const cePack = cePackList[i];

                if (cePack.id === action.payload.id) {
                    newCePackList.push(action.payload);
                    continue;
                }

                newCePackList.push(cePack);
            }

            return newCePackList;
        }

        case DELETE_SYSTEM_ADMIN_CE_PACK: {
            const cePackList = [...state];

            return cePackList.filter(cePack => cePack.id !== action.payload);
        }

        default:
            return state;
    }
}

export const getCePackById = (state, sid) => {
    return state.admin.cePacks.filter((cePack) => cePack.id === sid)[0];
}

export default cePackReducer;